export default {
  title: '{{company}} ha aggiornato il tuo orario di ritiro',
  new_time_label: 'Nuovo orario',
};
